export default {
    dramaReview: {
        drama: {
            info: '短剧信息',
            title: '短剧名称',
            creatorInfo: '创建信息',
            creatorUid: '创建人UID',
            createdAt: '创建时间',
            onlineAt: '上架时间',
            offlineAt: '下架时间',
            userId: '创建人 UID',
            cover: '封面',
            preview: '预览视频',
            description: '简介',
        },
        episode: {
            section: '剧集列表',
            no: '集数',
            title: '剧集名称',
            duration: '时长',
            playCount: '播放量',
            status: '状态',
            video: '视频',
            empty: '暂无剧集',
        },
        auditStatus: '审核状态',
        dramaStatus: '短剧状态',
        adminReviewStatus: {
            label: '管理员审核状态',
            Pending_FIRST_PUBLISH: '待审核 · 首次发布',
            Pending_ACTIVE_EDIT: '待审核 · 主动修改',
            Pending_PASSIVE_EDIT: '待审核 · 被动修改',
            Approved: '已通过',
            Rejected: '已拒绝',
            Offline: '已下架',
            Pending: '待审核',
            unknown: '未知',
        },
        badge: {
            label: '徽章',
            none: '无',
            setup: '设置徽章',
            confirm: '确认修改徽章？',
            OFFICIAL: '官方',
            PARTNER: '合作',
            VERIFIED: '认证',
            COMMUNITY: '社区',
            updateFailed: '徽章更新失败',
            option: {
                drama: {
                    OFFICIAL: '官方短剧',
                    PARTNER: '合作方短剧',
                    VERIFIED: '认证创作者短剧',
                    COMMUNITY: '社区短剧',
                },
            },
        },
        sort: {
            label: '排序',
            direction: '排序方向',
            created_at: '创建时间',
            updated_at: '更新时间',
            online_at: '上架时间',
            asc: '升序',
            desc: '降序',
        },
        reviewedStatus: '上次审核状态',
        publishedStatus: '上次审核状态',
        auditReason: '审核原因',
        auditRemark: '审核备注',
        auditRemarkPlaceholder: '选填',
        reject: {
            action: '驳回',
            reason: '驳回原因',
            reasonPlaceholder: '请填写驳回原因',
            reasonRequired: '驳回原因为必填',
            submit: '确认驳回',
        },
        approve: {
            action: '通过',
            reason: '审核备注',
            reasonPlaceholder: '选填',
            submit: '确认通过',
        },
        offline: {
            action: '下架',
            reason: '下架原因',
            reasonPlaceholder: '请填写下架原因',
            reasonRequired: '下架原因为必填',
            reasonMax: '下架原因最多 200 个字',
            submit: '确认下架',
            confirm: '确认下架短剧「{title}」？下架后不可再上架。',
        },
        history: {
            section: '操作历史',
            action: '历史',
            empty: '暂无操作历史',
            time: '时间',
            status: '状态',
            reason: '原因',
            reviewerId: '操作人',
            count: '{count} 条',
        },
        table: {
            actions: '操作',
        },
        search: {
            id: '短剧 ID',
            titleFuzzy: '短剧名称',
            userId: '创建人 UID',
            onlineAtStart: '上线开始时间',
            onlineAtEnd: '上线结束时间',
        },
        status: {
            PENDING_REVIEW: '待审核',
            REVIEW_REJECTED: '已拒绝',
            REVIEW_APPROVED: '通过',
            PENDING_ONLINE: '等待 NFT mint',
            ONLINE: '已上架',
            OFFLINE: '已下架',
            DELETED: '已删除',
            unknown: '未知',
        },
        confirmApproveDrama: '确认通过短剧「{title}」？',
        confirmRejectDrama: '确认驳回短剧「{title}」？',
        confirmApproveActor: '确认通过演员「{name}」？',
        confirmRejectActor: '确认拒绝演员「{name}」？',
        export: {
            button: '导出',
            success: '导出任务已提交，请到下载管理查看',
        },
        heatCoefficient: {
            label: '热度系数',
            updatedAt: '最近修改',
            edit: '编辑',
            submit: '保存',
            placeholder: '请输入热度系数',
            required: '热度系数为必填',
            range: '热度系数需在 {min} ~ {max} 之间，最多 2 位小数',
            decimals: '最多输入 2 位小数',
            hint: '热度系数为乘在原始热度上的乘数；保存后将异步重算历史热度，请稍后刷新列表查看结果。',
            updateFailed: '热度系数更新失败',
            confirmTitle: '设置热度系数 · {title}',
        },
    },
};
